import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }

import NotFound from "@ai-nc/a-components/src/pages/NotFound.vue";
import AccessDenied from "@ai-nc/a-components/src/pages/AccessDenied.vue";
import LoadingScreen from "@ai-nc/a-components/src/utilities/LoadingScreen.vue";

import { useStore } from "@/store";
import { watch } from "vue";
import { useRoute } from "vue-router";
import AToast from "@/components/AToast.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizationWrapper',
  setup(__props) {

const store = useStore();
const route = useRoute();
const auth = store.state.auth;

watch(
  () => auth.ready,
  () => {
    if (auth.ready) auth.handleCallback();
  },
  { immediate: true }
);

watch(
  () => auth.isLoading,
  () => {
    if (!auth.isLoading && !auth.isAuthenticated) auth.login();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AToast),
    (_unref(route).name === 'Not Found')
      ? (_openBlock(), _createBlock(NotFound, { key: 0 }))
      : (_unref(route).name === 'Access Denied')
        ? (_openBlock(), _createBlock(AccessDenied, { key: 1 }))
        : (_unref(auth).isLoading || !_unref(auth).isAuthenticated)
          ? (_openBlock(), _createBlock(LoadingScreen, {
              key: 2,
              class: "h-screen"
            }))
          : _renderSlot(_ctx.$slots, "default", { key: 3 })
  ]))
}
}

})